module.exports = __webpack_public_path__ + "media/winner_full_house_1.6ec87f3b.mp3";